import { useEffect, useState } from "react";
import api from "../api";
import EmailComposer from "../components/EmailComposer";
import { notifyMailChanged } from "../composerWindow";

const TOKEN_KEY = "crm_token";

export default function ComposerWindow() {
  const p = new URLSearchParams(window.location.search);
  const draftId = p.get("draft") || "";
  const mode = p.get("mode") || "new";
  const originalId = p.get("email") || "";
  const [draft, setDraft] = useState(null);
  const [original, setOriginal] = useState(null);
  const [ready, setReady] = useState(!draftId && !originalId);
  const [err, setErr] = useState("");

  useEffect(() => {
    document.title = "Scrivi email — CRM Silvia Casali";
    document.body.classList.add("composer-window-body");
    if (!localStorage.getItem(TOKEN_KEY)) { setErr("Sessione scaduta: rientra nel CRM e riprova."); return; }
    const jobs = [];
    if (draftId) jobs.push(api.get(`/emails/drafts/${draftId}`).then((r) => setDraft(r.data)));
    if (originalId) jobs.push(api.get(`/emails/${originalId}`).then((r) => setOriginal(r.data)));
    Promise.all(jobs)
      .then(() => setReady(true))
      .catch((e) => setErr(e.response?.data?.detail || "Non riesco ad aprire questa mail."));
  }, []); // eslint-disable-line

  const close = () => { notifyMailChanged(); window.close(); };

  if (err) {
    return (
      <div className="public-wrap"><div className="public-card" data-testid="composer-window-error">
        <h2 style={{ marginTop: 0 }}>Ops</h2>
        <p>{err}</p>
        <button className="btn" onClick={() => window.close()}>Chiudi la finestra</button>
      </div></div>
    );
  }
  if (!ready) return <div className="public-wrap"><p className="muted" data-testid="composer-window-loading">Apro la mail…</p></div>;

  return (
    <div className="composer-window" data-testid="composer-window">
      <EmailComposer
        mode={mode}
        draft={draft}
        original={original}
        prefillTo={p.get("to") || ""}
        prefillSubject={p.get("subject") || ""}
        onClose={close}
        onSent={() => notifyMailChanged()}
      />
    </div>
  );
}
